import React from 'react';
import { map } from 'lodash';
import { Row, Column, Text } from '../../common';

const DesktopCard = (shopperInfo) => (
    <Row
        backgroundColor='#FFFFFF'
        borderRadius={3}
        boxShadow
        noWrap
        justify='space-between'
    >
        { map(shopperInfo, ({ key, value, render, width, maxWidth, ...props }) => (
            <Column padding={15} justify='center' key={key} fixedWidth={width} maxWidth={maxWidth}>
                { render || <Text text={value} {...props} /> }
            </Column>
        ))}
    </Row>
);

export default DesktopCard;
